import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ClientService } from '../../../../services/client-service';

import { Timeline } from '../../../../models/client';

import { MatIconModule } from '@angular/material/icon';

@Component( {
  selector: 'app-timeline-component',
  imports: [
    DatePipe,
    RouterLink,
    MatIconModule,
  ],
  templateUrl: './timeline-component.html',
  styleUrl: './timeline-component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
} )
export class TimelineComponent implements OnInit, AfterViewInit
{
  constructor(
    private _clientService: ClientService,
    private _cdr: ChangeDetectorRef
  ) { }

  public clientId = input.required<string>();
  public timeline: Timeline | undefined;
  public legend: string = 'Timeline'

  async ngOnInit(): Promise<void>
  {
    // get data
    this.timeline = await this._clientService.getTimeline( this.clientId() );
    this._cdr.detectChanges();
  }
  async ngAfterViewInit(): Promise<void>
  {
    this._cdr.detectChanges();
  }





}
